import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, IconButton, Typography } from '@mui/material';
import Tooltip from '../Shared/CopyableTooltip';
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import DoneAllOutlined from "@mui/icons-material/DoneAllOutlined";

const TicketChatMessage = ({
  msg,
  isOwn,
  onEditStart,
  onDelete,
  onDownload,
  showEditActions,
  showReadReceipt,
  formatDate,
}) => {
  const ownBubble = {
    bg: "#0b3d87",
    color: "#fff",
    metaColor: "rgba(255,255,255,0.85)",
  };
  const otherBubble = {
    bg: "#f0f5ff",
    color: "#0b3d87",
    metaColor: "#808080",
  };
  const palette = isOwn ? ownBubble : otherBubble;

  return (
    <Box display="flex" justifyContent={isOwn ? "flex-end" : "flex-start"}>
      <Box
        sx={{
          maxWidth: "80%",
          px: 2,
          py: 1.5,
          borderRadius: 2,
          backgroundColor: palette.bg,
          color: palette.color,
        }}
      >
        {msg.message ? (
          <Typography sx={{ fontFamily: "Rubik", fontSize: 14, whiteSpace: "pre-wrap" }}>
            {msg.message}
          </Typography>
        ) : null}
        {msg.attachmentName ? (
          <Chip
            size="small"
            label={msg.attachmentName}
            onClick={() => onDownload(msg.id)}
            sx={{
              mt: msg.message ? 1 : 0,
              fontFamily: "Rubik",
              cursor: "pointer",
              color: palette.color,
              borderColor: palette.color,
            }}
            variant="outlined"
          />
        ) : null}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={0.5}
          mt={0.75}
          flexWrap="wrap"
        >
          {showEditActions ? (
            <>
              <Tooltip title="Modifica">
                <IconButton size="small" onClick={() => onEditStart(msg)}>
                  <EditOutlined sx={{ fontSize: 16, color: "#d4d4d4" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Elimina">
                <IconButton size="small" onClick={() => onDelete(msg.id)}>
                  <DeleteOutlined sx={{ fontSize: 16, color: "#ca5f5f" }} />
                </IconButton>
              </Tooltip>
            </>
          ) : null}
          <Typography sx={{ fontFamily: "Rubik", fontSize: 11, color: palette.metaColor }}>
            {formatDate(msg.timestamp)}
          </Typography>
          {showReadReceipt ? (
            <Tooltip title={msg.read ? "Letto" : "Inviato"}>
              <DoneAllOutlined
                sx={{
                  fontSize: 18,
                  color: msg.read ? "#00ff82" : "#cccccc",
                  opacity: msg.read ? 1 : 0.5,
                }}
              />
            </Tooltip>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

TicketChatMessage.propTypes = {
  msg: PropTypes.object.isRequired,
  isOwn: PropTypes.bool.isRequired,
  onEditStart: PropTypes.func,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func.isRequired,
  showEditActions: PropTypes.bool,
  showReadReceipt: PropTypes.bool,
  formatDate: PropTypes.func.isRequired,
};

TicketChatMessage.defaultProps = {
  onEditStart: null,
  onDelete: null,
  showEditActions: false,
  showReadReceipt: false,
};

export default React.memo(TicketChatMessage);
 